import { FormattedMessage } from 'react-intl';

export const PlatformProviders = {
  third_party: {
    label: (
      <FormattedMessage
        id="3rdPartyProvider"
        defaultMessage="3rd Party - Platform Provided by 3rd party"
      />
    ),
  },
  direct_reverse: {
    label: (
      <FormattedMessage
        id="directReverse"
        defaultMessage="Direct/Reverse"
      />
    ),
  },
};
